import Icon from "@ant-design/icons";

const SVG = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="25.305"
    height="25.305"
    viewBox="0 0 25.305 25.305"
  >
    <g
      id="Group_2126"
      data-name="Group 2126"
      transform="translate(-288.001 -845.999)"
    >
      <g
        id="search_3_"
        data-name="search (3)"
        transform="translate(298 855.748)"
      >
        <circle
          id="Ellipse_74"
          data-name="Ellipse 74"
          cx="4.5"
          cy="4.5"
          r="4.5"
          transform="translate(3 3.252)"
          fill="none"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.7"
        />
        <line
          id="Line_107"
          data-name="Line 107"
          x1="3.33"
          y1="3.58"
          transform="translate(10.775 10.775)"
          fill="none"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.7"
        />
      </g>
      <path
        id="Subtraction_10"
        data-name="Subtraction 10"
        d="M-3387.8,6551h-8.2a3,3,0,0,1-3-3v-16a3,3,0,0,1,3-3h11.8a3,3,0,0,1,3,3v7.5h-1.6V6532a1.4,1.4,0,0,0-1.4-1.4H-3396a1.4,1.4,0,0,0-1.4,1.4v16a1.4,1.4,0,0,0,1.4,1.4h8.2v1.6Z"
        transform="translate(3687 -5683)"
        fill="currentColor"
      />
      <g
        id="Rectangle_468"
        data-name="Rectangle 468"
        transform="translate(291 850)"
        fill="#fff"
        stroke="currentColor"
        strokeWidth="1"
      >
        <rect width="7" height="1.7" rx="0.85" stroke="none" />
        <rect x="0.5" y="0.5" width="6" height="0.7" rx="0.35" fill="none" />
      </g>
      <g
        id="Rectangle_469"
        data-name="Rectangle 469"
        transform="translate(291 854.3)"
        fill="#fff"
        stroke="currentColor"
        strokeWidth="1"
      >
        <rect width="12" height="1.7" rx="0.85" stroke="none" />
        <rect x="0.5" y="0.5" width="11" height="0.7" rx="0.35" fill="none" />
      </g>
      <g
        id="Rectangle_470"
        data-name="Rectangle 470"
        transform="translate(291 858.5)"
        fill="#fff"
        stroke="currentColor"
        strokeWidth="1"
      >
        <rect width="7" height="1.7" rx="0.85" stroke="none" />
        <rect x="0.5" y="0.5" width="6" height="0.7" rx="0.35" fill="none" />
      </g>
      <g
        id="Rectangle_471"
        data-name="Rectangle 471"
        transform="translate(293 866.4)"
        fill="#fff"
        stroke="currentColor"
        strokeWidth="1"
      >
        <rect width="7" height="1.6" rx="0.8" stroke="none" />
        <rect x="0.5" y="0.5" width="6" height="0.6" rx="0.3" fill="none" />
      </g>
      <g
        id="Rectangle_472"
        data-name="Rectangle 472"
        transform="translate(305.8 850.199) rotate(90)"
        fill="#fff"
        stroke="currentColor"
        strokeWidth="1"
      >
        <rect width="7" height="1.6" rx="0.8" stroke="none" />
        <rect x="0.5" y="0.5" width="6" height="0.6" rx="0.3" fill="none" />
      </g>
    </g>
  </svg>
);

const AntdIcon = (props) => <Icon component={SVG} {...props} />;

export default AntdIcon;
